<div class="ab-szene">
  <!-- 1. Der Plan: Raster und das Formular, das sich selbst zeichnet. -->
  <div class="ab-plan" aria-hidden="true">
    <svg class="ab-svg" [attr.viewBox]="ansicht" preserveAspectRatio="xMidYMid slice">
      <!-- Aussenkante des Belegs -->
      <rect
        class="ab-p ab-p--rahmen"
        [attr.x]="rahmen.x"
        [attr.y]="rahmen.y"
        [attr.width]="rahmen.breite"
        [attr.height]="rahmen.hoehe"
        pathLength="1"
      />

      <!-- Kopfbereich: Striche statt erfundener Namen -->
      <path
        *ngFor="let strich of kopfStriche; let i = index"
        class="ab-p ab-p--kopf"
        [class.ab-p--stark]="strich.stark"
        [attr.d]="'M' + strich.x + ' ' + strich.y + 'H' + (strich.x + strich.breite)"
        [style.--v]="0.2 + i * 0.06 + 's'"
        pathLength="1"
      />

      <!-- Trennlinien -->
      <path
        class="ab-p ab-p--trenner"
        [attr.d]="'M' + beleg.innenLinks + ' ' + beleg.kopfLinie + 'H' + beleg.innenRechts"
        style="--v: 0.34s"
        pathLength="1"
      />
      <path
        class="ab-p ab-p--trenner"
        [attr.d]="'M' + beleg.innenLinks + ' ' + beleg.spaltenLinie + 'H' + beleg.innenRechts"
        style="--v: 0.42s"
        pathLength="1"
      />
      <path
        class="ab-p ab-p--trenner"
        [attr.d]="'M' + beleg.summenLinks + ' ' + beleg.summenLinie + 'H' + beleg.innenRechts"
        style="--v: 0.78s"
        pathLength="1"
      />

      <!-- Positionszeilen: Kästchen und Bezeichnungsstrich -->
      <g *ngFor="let position of positionen; let i = index">
        <rect
          class="ab-p ab-p--kaestchen"
          [attr.x]="beleg.innenLinks"
          [attr.y]="kaestchenY(position)"
          [attr.width]="kaestchen.groesse"
          [attr.height]="kaestchen.groesse"
          [style.--v]="0.46 + i * 0.05 + 's'"
          pathLength="1"
        />
        <path
          class="ab-p ab-p--zeile"
          [attr.d]="
            'M' +
            (beleg.innenLinks + kaestchen.groesse + kaestchen.textAbstand) +
            ' ' +
            position.y +
            'H' +
            (beleg.innenLinks + kaestchen.groesse + kaestchen.textAbstand + position.breite)
          "
          [style.--v]="0.5 + i * 0.05 + 's'"
          pathLength="1"
        />
      </g>
    </svg>
  </div>

  <!-- 2. Das Objekt: vom Scan freigelegt, mit dem ausgefüllten Beleg darüber.
       Aussen und innen verschieben sich gegenläufig - der Inhalt steht still,
       nur das Fenster wandert (reine Transform-Animation, siehe Stilblatt). -->
  <div class="ab-real">
    <div class="ab-real-innen">
      <img
        class="ab-foto"
        src="assets/startbild/objekt.jpg"
        alt=""
        draggable="false"
      />
      <svg
        class="ab-svg"
        [attr.viewBox]="ansicht"
        preserveAspectRatio="xMidYMid slice"
        aria-hidden="true"
      >
        <!-- Der Beleg noch einmal, über dem Foto: Nach dem Scan ist die
             Planebene verdeckt: Ohne diese Wiederholung bliebe vom Formular nur
             ein Rahmen mit Zahlen übrig, die Gliederung wäre weg. -->
        <rect
          class="ab-rahmen-hell"
          [attr.x]="rahmen.x"
          [attr.y]="rahmen.y"
          [attr.width]="rahmen.breite"
          [attr.height]="rahmen.hoehe"
        />
        <g class="ab-formular">
          <path
            *ngFor="let strich of kopfStriche"
            [class.ab-formular--stark]="strich.stark"
            [attr.d]="'M' + strich.x + ' ' + strich.y + 'H' + (strich.x + strich.breite)"
          />
          <path [attr.d]="'M' + beleg.innenLinks + ' ' + beleg.kopfLinie + 'H' + beleg.innenRechts" />
          <path [attr.d]="'M' + beleg.innenLinks + ' ' + beleg.spaltenLinie + 'H' + beleg.innenRechts" />
          <path [attr.d]="'M' + beleg.summenLinks + ' ' + beleg.summenLinie + 'H' + beleg.innenRechts" />
          <path
            *ngFor="let position of positionen"
            class="ab-formular--zeile"
            [attr.d]="
              'M' +
              (beleg.innenLinks + kaestchen.groesse + kaestchen.textAbstand) +
              ' ' +
              position.y +
              'H' +
              (beleg.innenLinks + kaestchen.groesse + kaestchen.textAbstand + position.breite)
            "
          />
        </g>

        <!-- Belegnummer und Datum -->
        <text
          *ngFor="let kopf of kopfTexte; let i = index"
          class="ab-mono ab-kopf-text"
          [attr.x]="beleg.innenRechts"
          [attr.y]="kopf.y"
          text-anchor="end"
          [style.--v]="1.15 + i * 0.08 + 's'"
        >
          {{ kopf.text }}
        </text>

        <!-- Spaltenüberschrift -->
        <text
          class="ab-mono ab-spaltenkopf"
          [attr.x]="beleg.innenLinks"
          [attr.y]="beleg.spaltenkopfY"
          style="--v: 1.3s"
        >
          POSITION
        </text>
        <text
          class="ab-mono ab-spaltenkopf"
          [attr.x]="beleg.innenRechts"
          [attr.y]="beleg.spaltenkopfY"
          text-anchor="end"
          style="--v: 1.3s"
        >
          BETRAG
        </text>

        <!-- Die Prüfung: Zeile für Zeile rastet ein, eine bleibt offen. -->
        <g
          *ngFor="let position of positionen; let i = index"
          [class.ab-zeile--offen]="position.offen"
          [style.--i]="i"
        >
          <rect
            class="ab-marke"
            [attr.x]="beleg.innenLinks"
            [attr.y]="kaestchenY(position)"
            [attr.width]="kaestchen.groesse"
            [attr.height]="kaestchen.groesse"
          />
          <path
            *ngIf="!position.offen"
            class="ab-haken"
            [attr.d]="hakenPfad"
            [attr.transform]="
              'translate(' + beleg.innenLinks + ' ' + kaestchenY(position) + ')'
            "
            pathLength="1"
          />
          <text
            class="ab-mono ab-betrag"
            [attr.x]="beleg.innenRechts"
            [attr.y]="position.y + 4"
            text-anchor="end"
          >
            {{ position.betrag }}
          </text>
        </g>

        <!-- Summenblock -->
        <text
          class="ab-mono ab-summe-etikett"
          [attr.x]="beleg.summenLinks"
          [attr.y]="beleg.summeY"
          style="--v: 2.0s"
        >
          TOTAL {{ summe.waehrung }}
        </text>
        <text
          class="ab-mono ab-summe"
          [attr.x]="beleg.innenRechts"
          [attr.y]="beleg.summeY"
          text-anchor="end"
          style="--v: 2.08s"
        >
          {{ summe.text }}
        </text>

        <!-- Der Stempel setzt sich zum Schluss. -->
        <g
          class="ab-stempel"
          [attr.transform]="
            'rotate(' + stempel.drehung + ' ' + stempel.x + ' ' + stempel.y + ')'
          "
        >
          <rect
            [attr.x]="stempel.x - stempel.breite / 2"
            [attr.y]="stempel.y - stempel.hoehe / 2"
            [attr.width]="stempel.breite"
            [attr.height]="stempel.hoehe"
            rx="5"
          />
          <text
            class="ab-mono"
            [attr.x]="stempel.x"
            [attr.y]="stempel.y + 6"
            text-anchor="middle"
          >
            {{ stempel.text }}
          </text>
        </g>
      </svg>
    </div>
  </div>

  <div class="ab-scan" aria-hidden="true"><i></i></div>
</div>

<div class="ab-schleier" aria-hidden="true"></div>
<div class="ab-winkel" aria-hidden="true"></div>

<div class="ab-marke-block">
  <img
    class="ab-logo"
    src="assets/startbild/muessig_logo_navy.png"
    alt="Müssig"
    draggable="false"
  />
  <h1 class="ab-titel"><span>AB/RE-Portal</span></h1>
  <ol class="ab-schritte">
    <li *ngFor="let schritt of schritte; let i = index" [style.--i]="i">
      <i aria-hidden="true"></i>{{ schritt }}
    </li>
  </ol>
</div>
